import Layout from 'components/layouts/Layout'
import { GetStaticProps } from 'next'
import { useTranslations } from 'next-intl'
import { ReactElement } from 'react'
import DocPage from '../../../components/DocPage'
import FeaturesLayout from '../../../components/layouts/features/FeaturesLayout'

const translations = "orcamentacao"

const Doc = () => {
  const t = useTranslations(translations)

  return (
    <DocPage group={t("group")} title={t("title")} metadata={{ title: t("metadata-title"), description: t("metadata-description") }} previous={{ name: t("previous-name"), to: t("previous-to") }} next={{ name: t("next-name"), to: t("next-to") }}>
      <p>{t("details-1")}</p>
      <h2>{t("heading-1")}</h2>
      <p>{t("details-2")}</p>
      <h2>{t("heading-2")}</h2>
      <p>{t("details-3")}</p>
      <h2>{t("heading-3")}</h2>
      <p>{t("details-4")}</p>
      <h2>{t("heading-4")}</h2>
      <p>{t("details-5")}</p>
      <p>{t("details-6")}</p>
      <h2>{t("heading-5")}</h2>
      <p>{t("details-7")}</p>
      <h2>{t("heading-6")}</h2>
      <p>{t("details-8")}</p>
    </DocPage>
  )
}

export const getStaticProps: GetStaticProps = async context => {
  return {
    props: {
      context,
      messages: (await import(`../../../lang/${context.locale}-docs.json`)).default
    }
  }
}

Doc.getLayout = function getLayout(page: ReactElement) {
  return (
    <Layout variant='secondary'>
      <FeaturesLayout >
        {page}
      </FeaturesLayout>
    </Layout>
  )
}

export default Doc
